module.exports = __webpack_public_path__ + "img/icon_2_1.dcdf7687.png";